import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";
import { baseURL } from "../../Config/config";
import { Typography, Link } from "@mui/material";
import Excel from "../../images/excel.jpeg";
import Plot from "react-plotly.js";
import Projectcolors from "../../Utils/Colors";
import GlobalLoader from "../CommonC/GlobalLoader";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Button from "@mui/material/Button";





import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

function ResultsRisk(props) {
  const [getLoader, setGetLoader] = React.useState(false);
  const [errdownload, seterrdownload] = React.useState(false);
    const [isSelected, setIsSelected] = useState(false);
  
  const [sheetData, setSheetData] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [columns, setColumns] = useState([
    "equipment_type",
    "asset_tag",
    "functional_location",
    "unit_area",
    "P_f_3m_pct",
    "P_f_6m_pct",
    "P_f_9m_pct",
    "lambda_base_per_day",
    "lambda_multiplier",
    "lambda_adj_per_day",
  ]);
  const [filter, setFilter] = useState("All");
  const [equipmentTypes, setequipmentTypes] = useState(["hey", "hello"]);
  const filteredData =
    filter === "All"
      ? sheetData
      : sheetData.filter((row) => row.equipment_type === filter);

  React.useEffect(() => {
    getSheet1();
  }, []);

  const getSheet1 = () => {
    setGetLoader(true);

    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getSheet1?projectID=${ProjectID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())

      .then((data) => {
        setSheetData(data.sheet1);
        setGetLoader(false);
        setIsSelected(true);
        const types = ["All", ...data.equipmentTypes];
        setequipmentTypes(types);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("caught it!", err);
      });
  };
  const NextStep = () => {
            props.handleNextStep();
         
    };

  function downloadPredictions() {
    const projectID = sessionStorage.getItem("projectID");
    const projectName = sessionStorage.getItem("projectName");
    setGetLoader(true);
    fetch(
      `${baseURL}/downloadpredictions?projectID=${projectID}&projectName=${projectName}`
    )
      .then((res) => res.blob())
      .then((blob) => {
        var file = new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var url = URL.createObjectURL(file);
        var link = document.createElement("a");
        link.download = projectName + ".xlsx";
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        fetch(`${baseURL}/deleteriskfile?projectID=${projectID}`, {
          method: "POST",
          body: JSON.stringify(projectName),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((result) => {
            setGetLoader(false);
          })
          .catch((error) => {
            console.error("Error:", error);
            setGetLoader(false);
          });
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        seterrdownload(true);
        console.log("Error", err);
      });
  }
  return (
    <div>
      <Paper sx={{mt:5}}>
        <Box display="flex" gap={2}>
           <Box flex={1} p={2} sx={{width:'300px',ml:3}} elevation = {3} component={Paper}>
            <div
              onClick={() => downloadPredictions()}
              style={{
                //display: "flex",
                //flexDirection: "row",
                //alignItems: "center",
                float: "right",
                ml: 100,
                cursor: "pointer",
              }}
            >
              <Link
                sx={{
                  fontSize: "13px",
                  fontStyle: "bold",
                  float: "left",
                  ml: 0,
                  mr: 0.5,
                  // marginTop: 0,
                  // marginBottom: 1,
                  textTransform: "none",
                }}
                variant="contained"
                size="large"
                textTransform="none"
              >
                <img
                  alt="arrow"
                  src={Excel}
                  style={{
                    marginTop: 0,
                    marginBottom: 1,
                    marginRight: 1,
                    width: 30,
                    height: 30,
                  }}
                />
                <span style={{ marginLeft: 3 }}> Download Project Report</span>
              </Link>
            </div>
            {/* Dropdown filter */}
            <FormControl sx={{ mb: 0, minWidth: 200 , height:100 ,mt:2 }}>
              <InputLabel sx={{fontSize:12}}>Equipment Type</InputLabel>
              <Select
                value={filter}
                label="Equipment Type"
                onChange={(e) => setFilter(e.target.value)}
              >
                {equipmentTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 550, maxWidth: "100%", overflow: "auto"}}
              elevation = {3}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    {columns.map((col) => (
                      <TableCell key={col} sx={{ fontWeight: "bold" ,fontSize:14}}>
                        {col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.map((row, idx) => (
                    <TableRow key={idx}>
                      {columns.map((col) => (
                        <TableCell key={col} sx={{fontSize:12}}>{row[col]}</TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Button
                    disabled={!isSelected}
                    onClick={NextStep}
                    // mt={5}
                    sx={{
                      // marginLeft: 37,
                      // width: 10,
                      float:"right",
                      minWidth: 7,
                      // height: 33,
                      fontSize: 13,
                      // marginTop: 1,
                      backgroundColor: Projectcolors.primary,
                      color: "white",
                      fontStyle: "bold",
                      margin: "29px 0 0 240px",
                    }}
                    variant="contained"
                    // size="large"
                  >
                    <ChevronRightIcon sx={{ fontSize: "18px" }} />
                  </Button>
          </Box>
          <Box flex={1} p={2} sx={{ mr:3 }} elevation = {3} component={Paper}>
            
                  <Typography sx={{fontSize:16}}>Equipment Type :  {filter}</Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 2,
                mt:2,
                height: 640,          // fixed height
    overflowY: "auto",    // scroll vertically if content exceeds height
    p: 2,
                
              }}
              elevation = {3} component={Paper}
            >
              {filteredData.map((row, idx) => (
                <Plot
                  key={idx}
                  data={[
                    {
                      type: "bar",
                      x: ["3m", "6m", "9m"],
                      y: [row.P_f_3m_pct, row.P_f_6m_pct, row.P_f_9m_pct],
                      marker: { color: Projectcolors.primary },
                      text: [row.P_f_3m_pct, row.P_f_6m_pct, row.P_f_9m_pct], // values
                      textposition: "auto",
                    },
                  ]}
                  layout={{
                    title: `${row.unit_area} - ${row.functional_location}`,
                    xaxis: { title: "Failure Probability (%)" },
                    yaxis: { title: "Value" },
                    width: 250,
                    height: 250,
                    margin: { t: 40, b: 40, l: 40, r: 20 },
                  }}
                />
              ))}
            </Box>
            
          </Box>
          
         
        </Box>
         {getLoader ? <GlobalLoader /> : null}
      </Paper>
    </div>
  );
}

export default ResultsRisk;
